import React from "react";

const FormSection = ({ title, children }) => {
  return (
    <div className="form-section">
      {title ? <div className="title">{title}</div> : null}
      <div className="children">{children}</div>
    </div>
  );
}

export default FormSection;
